import { CraftMan,Intergirty,Innovation  } from '../assets/icons/index'
import {Architecture,Fabrication,Recident,School,Electrictiy,CCTV_Work,Garden,Industrial_Work,Painting,Labour_Work,Commerical,Renovation,RoadConstruction} from '../assets/icons/services_icon/index'
import {AMGreen,Winder,Nagaarujan,Vernoma,Himigiri, BethChange, JCB, PodarSchool, SunPharama,Rubina,UnitedWay, AweshFoundation, Lbct } from '../assets/icons/partner_icon/index'
import { Emergency, Earth, Education,Employment,House,Medical,Skills,Water } from '../assets/icons/award_icon';


export const HeroData = [
    {
        count: 400,
        name: 'LABOUR',
    },
    {
        count: 300,
        name: 'COMPLETED PROJECTS',
    },
    {
        count: 15,
        name: 'YEARS',
    },
    {
        count: 200,
        name: 'HAPPY CLIENTS',
    },
];

export const OurValue =[
    {
        icon:CraftMan,
        title:"Quality and Craftmanship",
        description:"We prioritize top-tier quality and cratfsmanship in every project, ensuring that all work meets the highest standards for durability and excellence.",
    },
    {
        icon:Intergirty,
        title:"Innovation and Efficiency",
        description:"We embrace innovative technologies and practices to streamline processes, improve efficiency, and deliver projects on time and within budget.",
    },
    {
        icon:Innovation,
        title:"Integrity and Transparency",
        description:"We uphold the highest levels of integrity and transparency in all our dealings, fostering trust and long-term relationships with clients, partners, and stakeholders.",
    },
]

export const TransformIdea=[
    {
        icon:Commerical,
        title:"Commercial Project"
    },
    {
        icon:Recident,
        title:"Residential Project"
    },
    {
        icon:Renovation,
        title:"Renovation"
    },
    {
        icon:Architecture,
        title:"Architecture Design"
    },
    {
        icon:RoadConstruction,
        title:"Rcc Road"
    },
    {
        icon:Fabrication,
        title:"Fabrication Shade"
    },
]

export const Partner=[
    {
        icon: SunPharama
    },
    {
        icon: BethChange
    },
    {
        icon: JCB
    },
     {
        icon: AMGreen
    },
    {
        icon: PodarSchool
    },
    {
        icon: Rubina
    },
    {
        icon:Himigiri
    },
    {
        icon:Vernoma
    },
    {
        icon:Winder
    },
    {
        icon:UnitedWay,
    },
    
    {
        icon:Nagaarujan
    },
    
     {
        icon: AweshFoundation
    },
    {
        icon:Lbct
    }
    
]

export const AboutUsEmployee=[
    {
        name:'Virat Kohli',
        desc:"Chase Master"
    },
    {
        name:'Rohit Sharma',
        desc:"Hit Man"
    },
    {
        name:'Ms Dhoni',
        desc:"Finisher"
    },
]

export const ServicesSectionDetails=[
    {
        icon:Commerical,
        title:"Commercial Project"
    },
    {
        icon:Recident,
        title:"Residential Project"
    },
    {
        icon:School,
        title:"Smart Class & Anganwadi"
    },
    {
        icon:Renovation,
        title:"Renovation"
    },
    {
        icon:Painting,
        title:"Painting"
    },
    {
        icon:Labour_Work,
        title:"Labour Supply "
    },
    {
        icon:Architecture,
        title:"Architecture Design"
    },
    {
        icon:Garden,
        title:"Education Garden Development"
    },
    {
        icon:RoadConstruction,
        title:"Rcc Road"
    },
    {
        icon:Fabrication,
        title:"Fabrication Shade"
    },
    {
        icon:CCTV_Work,
        title:"CCTV Installation & services"
    },
    {
        icon:Industrial_Work,
        title:"Industrial Maintenance Work"
    },
   
    {
        icon:Electrictiy,
        title:"Electricity Work "
    },
]

export const Award_Cards = [
    {
      title: "Support for Local Education Initiatives",
      description: "Shree Datt Guru Enterprise is committed to the future of our youth. We provide scholarships, donate books and supplies, and collaborate with local schools to enhance learning opportunities for underprivileged children.",
      image: Education
    },
    {
      title: "Health and Well-being Programs",
      description: "Our commitment to the community extends to promoting health and wellness. We organize health camps, providing free medical check-ups, hygiene kits, and educational workshops on maintaining good health, especially in rural areas where healthcare access is limited.",
      image: Medical
    },
    {
      title: "Disaster Relief and Emergency Assistance",
      description: "In times of natural disasters, Shree Datt Guru Enterprise acts swiftly to offer relief to affected communities. We provide emergency supplies, assist in rebuilding efforts, and support those in need by contributing resources, manpower, and financial aid during critical times.",
      image: Emergency
    },
    {
      title: "Promoting Clean and Green Environment",
      description: "Shree Datt Guru Enterprise is committed to protecting the environment. We organize tree plantation drives, clean-up campaigns, and advocate for waste reduction and recycling in local communities. Through these efforts, we aim to create a cleaner, greener, and more sustainable environment for future generations.",
      image: Earth
    },
    {
      title: "Affordable Housing for the Underprivileged",
      description: "We recognize the importance of providing safe and affordable housing for all. As part of our CSR efforts, we have been involved in constructing affordable homes for low-income families, helping to create a stable and secure living environment for those who need it most.",
      image: House
    },
    {
      title: "Skill Development and Vocational Training",
      description: "Understanding the need for employment opportunities, we offer skill development and vocational training programs to help individuals gain new skills and improve their employability. These initiatives are focused on sectors like construction, carpentry, plumbing, and electrical work, empowering individuals to build better futures.",
      image: Skills
    },
    {
      title: "Water Conservation Projects",
      description: "In areas facing water scarcity, Shree Datt Guru Enterprise works on projects that promote water conservation and management. This includes constructing rainwater harvesting systems and providing water storage solutions for communities in need, helping ensure sustainable water access for all.",
      image: Water
    },
    {
      title: "Support for Elderly and Vulnerable Groups",
      description: "We believe in caring for all members of the community, especially the elderly and vulnerable groups. Through outreach programs and partnerships with local organizations, we provide financial support, medical care, and social services to ensure that these groups lead a dignified and comfortable life.",
      image: Medical
    },
    {
      title: "Promoting Local Employment",
      description: "Shree Datt Guru Enterprise is committed to boosting the local economy by hiring local labor for our construction projects. By providing jobs and fair wages to the surrounding communities, we help uplift families and contribute to the overall development of the region.",
      image: Employment
    }
  ];